
/**
 * Create a clone with the exact same dimensions as the original cell.
 * @param {HTMLTableCellElement} cell A table cell that should be copied
 * @returns {HTMLTableCellElement} A clone of the original table cell.
 */
export function cloneCell(cell) {
    const cellClone = cell.cloneNode();
    // The dimensions of the new table might no longer be the same, so re-apply box model settings from the original cell.
    // Need the div block in order to simulate exact size. Setting the width directly on the tds does nothing.
    const cellContents = document.createElement("div");
    const cellStyle = window.getComputedStyle(cell);
    const width = Number.parseInt(cellStyle.width);
    const height = Number.parseInt(cellStyle.height);
    const paddingLeft = Number.parseInt(cellStyle.paddingLeft);
    const paddingRight = Number.parseInt(cellStyle.paddingRight);
    const paddingTop = Number.parseInt(cellStyle.paddingTop);
    const paddingBottom = Number.parseInt(cellStyle.paddingBottom);

    cellContents.style.width = width - paddingLeft - paddingRight + "px";
    cellClone.style.paddingLeft = cellStyle.paddingLeft;
    cellClone.style.paddingRight = cellStyle.paddingRight;
    cellClone.style.paddingTop = cellStyle.paddingTop;
    cellClone.style.paddingBottom = cellStyle.paddingBottom;
    cellClone.style.minWidth = cellStyle.width;
    cellClone.style.maxWidth = cellStyle.width;
    cellClone.style.height = height - paddingTop - paddingBottom + "px";
    // Place children of the th under a new parent.
    cellContents.innerHTML = cell.innerHTML;
    cellClone.appendChild(cellContents);
    return cellClone;
}

/**
 * Return the maximum cell width of the HTML element containing tr children.
 * @param {HTMLElement} elementTr An HTML element that contains tr children.
 * @returns {number} The cell width of the element.
 */
export function computeMaxWidth(elementTr) {
    return Array.from(elementTr.querySelectorAll("tr"))
        .reduce((maxWidth, tr) => {
            return Math.max(maxWidth, tr.querySelectorAll("td, th").length)
        }, 0)
}

/**
 * Return a jquery-style computed offset object for the given element.
 * @param {HTMLElement} el
 * @returns {{ top: number, left: number }} The offset position of the element.
 */
export function offset(el) {
    // Take implementation from jQuery source code: https://github.com/jquery/jquery/blob/master/src/offset.js
    if (!el.getClientRects().length) {
        return { top: 0, left: 0 }
    }

    const rect = el.getBoundingClientRect()
    const win = el.ownerDocument.defaultView
    return {
        top: rect.top + win.pageYOffset,
        left: rect.left + win.pageXOffset
    }
}
